import React from "react"
import { ViewInAr as ViewInArIcon } from "@mui/icons-material"
import { IconButton } from "@mui/material"
import { useCallback } from "react"
import PropTypes from "prop-types"

const Link3DCellRenderer = (props) => {

    const onClick = useCallback(() => {
        window.open(`https://padms.net/padmsnet/searchlink?shape=%E8%A1%97%E8%B7%AF%E6%A8%B9+uniquekey+${props.data.tree_id}`, {target: "_blank"})
    }, [props.data?.tree_id])

    return (
        <IconButton onClick={onClick}>
            <ViewInArIcon size="20" />
        </IconButton>
    )

}
Link3DCellRenderer.propTypes = {
    data: PropTypes.any,
}

export default Link3DCellRenderer